if(!customElements.get('collapsible-text')) {
    class CollapsibleText extends HTMLElement {
        constructor() {
            super();

            const button = this.querySelector('button[aria-controls]');
            const content = this.querySelector('.collapsible-text__content');
            const isClamped = element => element.scrollHeight > element.clientHeight

            if(button){
                new ResizeObserver(event => {
                    if(this.isClamped(event[0].target) || event[0].target.classList.contains('expanded')){
                        button.style.display = 'flex';
                    } else {
                        button.style.display = 'none';
                    }
                }).observe(content);

                button.addEventListener('click', () => {
                    if(button.getAttribute('aria-expanded') == 'false'){
                        button.setAttribute('aria-expanded', 'true');
                        button.innerText = window.locales.read_less;
                        content.classList.add('expanded');
                    } else {
                        button.setAttribute('aria-expanded', 'false');
                        button.innerText = window.locales.read_more;
                        content.classList.remove('expanded');
                    }
                });
            }
        }

        isClamped(element) {
            return element.scrollHeight > element.clientHeight;
        }
    }

    customElements.define('collapsible-text', CollapsibleText);
}
 